import React, { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, db } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import "./Login.css";


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [invalidFields, setInvalidFields] = useState({ email: false, password: false });

  const navigate = useNavigate(); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Setzt Fehler zurück
    setInvalidFields({ email: false, password: false });

    if (!email || !password) {
      setError("Bitte fülle beide Felder aus.");
      setInvalidFields({ email: !email, password: !password });
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError("Fehler: Falsche Email oder Passwort.");
      setInvalidFields({ email: true, password: true });
    }
  };

  // 🔹 Google Login Funktion
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // 🔹 Prüfen, ob der User bereits in Firestore registriert ist
      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);

      if (!userDoc.exists()) {
        setError("Kein registriertes Konto mit dieser Email gefunden.");
        auth.signOut(); // Falls kein Konto existiert, den User direkt ausloggen
        return;
      }

      navigate("/dashboard");
    } catch (err) {
      setError("Fehler beim Google Login: " + err.message);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="modal-content rounded-4 shadow" style={{ width: "400px" }}>
        <div className="modal-header p-5 pb-4 border-bottom-0">
          <h1 className="fw-bold mb-0 fs-2">Anmelden</h1>
        </div>

        <div className="modal-body p-5 pt-0">
          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input 
                type="email" 
                className={`form-control rounded-3 ${invalidFields.email ? "is-invalid" : ""}`}
                id="floatingInput" 
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="floatingInput">Email address</label>
              {invalidFields.email && <div className="invalid-feedback">Ungültige Email.</div>}
            </div>
            <div className="form-floating mb-3">
              <input 
                type="password" 
                className={`form-control rounded-3 ${invalidFields.password ? "is-invalid" : ""}`} 
                id="floatingPassword" 
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="floatingPassword">Passwort</label>
              {invalidFields.password && <div className="invalid-feedback">Falsches Passwort.</div>}
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">Einloggen</button>

            <div className="text-center mt-2">
              <a href="/reset-password" className="text-decoration-none">Passwort vergessen? </a>
              <p> </p>
              <a href="register" className="text-decoration-none">Registrieren</a>
            </div>

            <button 
              class="google-btn"
              style={{ width: "100%", marginTop: "10px" }}
              type="button"
              onClick={handleGoogleLogin}
            >
              <img src="https://www.svgrepo.com/show/475656/google-color.svg" style={{ width: "24px" }} alt="Google logo" />
              <span>
                Sign in with Google
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
